import loadable from '@utils/loadable';

import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';
import Preloader from '../../../components/Preloader';

const MainTrending = loadable(
  () => import('../../../components/MainTrending'),
  { fallback: <div style={{ height: '100vh' }}><Preloader loading /></div> },
);

const TrendingLayout = ({
  user, watchlists,
}) => (
  <MainTrending
    user={user}
    watchlists={watchlists}
  />
);

export default withMetatag(TrendingLayout, 'news/trending');
